export const FETCH_CERTIFICATES_APPLICATION = 'FETCH_CERTIFICATES_APPLICATION';
export const FETCH_CERTIFICATES_APPLICATION_SUCCESS = 'FETCH_CERTIFICATES_APPLICATION_SUCCESS';
export const FETCH_CERTIFICATES_APPLICATION_ERROR = 'FETCH_CERTIFICATES_APPLICATION_ERROR';

export const DOWNLOAD_CERTIFICATE = 'DOWNLOAD_CERTIFICATE';
export const DOWNLOAD_CERTIFICATE_SUCCESS = 'DOWNLOAD_CERTIFICATE_SUCCESS';
export const DOWNLOAD_CERTIFICATE_ERROR = 'DOWNLOAD_CERTIFICATE_ERROR';

export const FETCH_CERTIFICATES_APPLICATION_DETAIL = 'FETCH_CERTIFICATES_APPLICATION_DETAIL';
export const FETCH_CERTIFICATES_APPLICATION_DETAIL_SUCCESS = 'FETCH_CERTIFICATES_APPLICATION_DETAIL_SUCCESS';
export const FETCH_CERTIFICATES_APPLICATION_DETAIL_ERROR = 'FETCH_CERTIFICATES_APPLICATION_DETAIL_ERROR';

export const VALIDATE_CERIFICATES = 'VALIDATE_CERIFICATES';
export const VALIDATE_CERIFICATES_SUCCESS = 'VALIDATE_CERIFICATES_SUCCESS';
export const VALIDATE_CERIFICATES_ERROR = 'VALIDATE_CERIFICATES_ERROR';

// valuation certificate constants
export const UPDATE_VALUATION_TYPE = 'UPDATE_VALUATION_TYPE';
export const ACTION_START = 'ACTION_START';
export const ACTION_SUCCESS = 'ACTION_SUCCESS';
export const ACTION_ERROR = 'ACTION_ERROR';
export const UPDATE_CERTIFICATE_TYPE = 'UPDATE_CERTIFICATE_TYPE';
export const CERTIFICATE_CANCEL_APPLICATION = 'CERTIFICATE_CANCEL_APPLICATION';
export const CERTIFICATE_CANCEL_APPLICATION_SUCCESS = 'CERTIFICATE_CANCEL_APPLICATION_SUCCESS';
export const CERTIFICATE_CANCEL_APPLICATION_ERROR = 'CERTIFICATE_CANCEL_APPLICATION_ERROR';
export const CHANGE_STEP = 'CHANGE_STEP';
export const PAYMENT_BREAKDOWN_SUCCESS = 'PAYMENT_BREAKDOWN_SUCCESS';
export const SET_PROPERTY_SUCCESS = 'SET_PROPERTY_SUCCESS';
export const SET_EVALUATION_REASONS = 'SET_EVALUATION_REASONS';
export const UPDATE_CERTIFICATE_STATE = 'UPDATE_CERTIFICATE_STATE';
export const CERTIFICATE_CLEAR_DATA = 'CERTIFICATE_CLEAR_DATA';

export const CERTIFICATES_CLEAR_ERROR = 'CERTIFICATES_CLEAR_ERROR';
export const CERTIFICATES_LOADING = 'CERTIFICATES_LOADING';
export const CERTIFICATES_SUCCESS = 'CERTIFICATES_SUCCESS';
export const CERTIFICATES_ERROR = 'CERTIFICATES_ERROR';
export const CERTIFICATES_CLEAR_APPLICATION = 'CERTIFICATES_CLEAR_APPLICATION';
export const CERTIFICATES_FETCH_DOCUMENTS_SUCCESS = 'CERTIFICATES_FETCH_DOCUMENTS_SUCCESS';
export const CERTIFICATES_FETCH_OWNRESHIP_PROPERTIES_SUCCESS = 'CERTIFICATES_FETCH_OWNRESHIP_PROPERTIES_SUCCESS';
